export const setB2bBlocksData = (value) => {
    return {
      type: 'SET_B2B_BLOCKS_DATA',
      payload: { data: value}
    };
  };